/**
 * Centralized date utility functions for the application
 */

/**
 * Format a date to DD/MM/YYYY format
 * @param date - Date to format (Date object or date string)
 * @returns Date in DD/MM/YYYY format
 */
export const formatDateToDDMMYYYY = (date: Date | string): string => {
  if (!date) return '';
  
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
};

/**
 * Convert a date to YYYY-MM-DD format for API calls
 * @param date - Date to convert (Date object or date string)
 * @returns Date in YYYY-MM-DD format
 */
export const formatDateForAPI = (date: Date | string): string => {
  if (!date) return '';
  
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Parse a DD/MM/YYYY formatted date string to a Date object
 * @param dateString - Date string in DD/MM/YYYY format
 * @returns Date object
 */
export const parseDateFromDDMMYYYY = (dateString: string): Date => {
  const [day, month, year] = dateString.split('/');
  return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
};

/**
 * Check if a string is a valid date
 * @param dateString - String to check
 * @returns True if valid date, false otherwise
 */
export const isValidDate = (dateString: string): boolean => {
  const date = new Date(dateString);
  return !isNaN(date.getTime());
};


